<template>
  <li>
    <span
      class="block-name"
      :class="{ clickable: block.type === 'content-block-html' }"
      @click="() => blockClicked(block)"
      >{{ block.title }}</span
    >
    <span class="actions">
      <action-button
        v-if="newVersionAvailable"
        icon="fa-file-import"
        tooltip="New version available"
        @click="$emit('block-refresh', block)"
      />
    </span>
  </li>
</template>
<script>
import documentModel from "@/mixins/documentModel";
import { HTML_CONTENT_BLOCK } from "@/constants/contentControlTypes";

export default {
  mixins: [documentModel],
  props: {
    block: {
      required: true,
    },
  },
  computed: {
    contentControls: function () {
      if (this.documentModel) {
        var contentControls = this.documentModel.findContentControlBySystemName(
          this.block.systemName
        );

        return contentControls;
      }

      return [];
    },
    blockUsed: function () {
      if (this.contentControls.length > 0) {
        return this.contentControls.some((c) => c.type == HTML_CONTENT_BLOCK);
      }

      return false;
    },
    newVersionAvailable: function () {
      if (this.contentControls.length > 0) {
        return this.contentControls.some(
          (c) =>
            c.type == HTML_CONTENT_BLOCK &&
            c.version.number < this.block.versionNumber
        );
      }

      return false;
    },
  },
  methods: {
    blockClicked: function (block) {
      if (block.type === "content-block-html") {
        this.$emit("insert-block", block);
      }
    },
  },
  emits: ["block-refresh", "insert-block"],
};
</script>
<style lang="scss" scoped>
li {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  & > .block-name {
    font-style: italic;

    &.clickable {
      cursor: pointer;
    }
  }
}
</style>
